const mountTitle = (title) => {
  if (title === 'general') {
    return '- Geral'
  }

  return ''
}

export default mountTitle
